<div class="cb-margin-top start-center flex-row">
    <h3 class="mat-headline-6 flex">Document Notifications</h3>
    <button mat-raised-button (click)="newItemClicked()" color="primary">
        Add Document Notification
    </button>
</div>
<cb-table class="cb-margin-top" [loaded]="true" [stringColumns]="columns" [maxHeightOffset]="256">
    @for (result of searchResults; track result) {
        <tr cbTableRow>
            <cb-td-text [value]="result.documentType?.label"></cb-td-text>
            <cb-td-text [value]="result.userTag?.label"></cb-td-text>
            <cb-td-text [value]="result.team?.label"></cb-td-text>
            <cb-td-text [value]="DOCUMENT_ACTION_ENUM[result.documentAction]"></cb-td-text>
            <cb-td-text [value]="result.notificationTemplate?.label"></cb-td-text>
            <cb-td-checkbox [value]="result.isActive"></cb-td-checkbox>
            <td cbTableStickyCol="end" cbTableShrinkCol>
                <button mat-icon-button (click)="editItemClickedForDto(result)">
                    <mat-icon> edit </mat-icon>
                </button>
            </td>
        </tr>
    }
</cb-table>
